import React from 'react';
import _ from 'underscore';
import { DropdownSelect } from '@shoflo/polymer/components/DropdownSelect/DropdownSelect';
import roles from 'constants/Roles';

const humanize = require('underscore.string/humanize');

const CrewRolePicker = ({ value, onChange, userId }) => {
  const options = _.map(roles, (roleValue, name) => ({
    id: `${roleValue}_${userId}`,
    label: humanize(name),
    checked: roleValue === value,
  }));

  const handleRoleSelect = (event) => {
    const checkedValue = event.target.id.split('_')[0];

    if (checkedValue !== value) {
      onChange(checkedValue);
    }
  };

  return (
    <DropdownSelect
      type="radio"
      onClick={handleRoleSelect}
      options={options}
      srMessage="Permission level selection"
      id={`permission-select-${userId}`}
    />
  );
};

export default CrewRolePicker;
